import React, { FC, useState } from "react";
import classes from "./LicenseKeyModal.module.scss";
import { createPortal } from "react-dom";
import { useAddLicense } from "../../../hooks/license/useAddLicense";
import Typography, { TypographyVariant } from "../../Typography/Typography";
import { CustomTextField } from "../../Admin/CustomTextField/CustomTextField";
import { Button } from "../../Admin/Button/Button";
import classNames from "classnames";
import modalBase from "../../ModalBase/ModalBase.module.scss";

type Props = {
  onClose: () => void;
};

export const LicenseKeyModal: FC<Props> = ({ onClose }) => {
  const [keyValue, setKeyValue] = useState("");
  const { addLicense, isAddLicensePending } = useAddLicense(false, onClose);

  return (
    <>
      {createPortal(
        <div
          className={classNames(
            modalBase.modal,
            modalBase.active,
            classes.modalwWrapper,
          )}
        >
          <div
            className={classNames(
              modalBase.container,
              classes.licenseKeyModalContainer,
            )}
            onClick={(e) => e.stopPropagation()}
          >
            <Typography
              variant={TypographyVariant.h2_semibold}
              className={classes.message}
            >
              Новый ключ лицензии
            </Typography>

            <CustomTextField
              value={keyValue}
              onChange={(e) => setKeyValue(e.target.value)}
              placeholder="Введите новый ключ"
              labelName={"Новый ключ"}
            />

            <div className={classes.confirmButtonsContainer}>
              <Button content="Отмена" btnStyle="white" onClick={onClose} />
              <Button
                content="Сохранить"
                btnStyle="blue"
                onClick={() => addLicense({ key: keyValue })}
                isDisabled={!keyValue || isAddLicensePending}
                isLoading={isAddLicensePending}
              />
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};
